export default __webpack_public_path__ + "static/GRID22-global-map-158d61ed7dcfecadd517f211329a18b9.png";